import { API_ROOT } from '../../config/config'
import { doDeleteBody, doGet, doPost } from './utils'

// const API_ROOT = 'http://localhost:9011/api'

export const searchWaitApporve = (request, approveType, pagesize, pagenumber) => {
  const url = `${API_ROOT}/approver/multiple/approve/search/${approveType}/pagesize/${pagesize}/pagenumber/${pagenumber}`
  return doPost(url, request)
}

export const searchWaitNotApporve = (request, approveType, pagesize, pagenumber) => {
  const url = `${API_ROOT}/approver/multiple/reject/search/${approveType}/pagesize/${pagesize}/pagenumber/${pagenumber}`
  return doPost(url, request)
}

// export const getApproveMultiPage = (pagesize, pagenumber) => {
//   const url = `${API_ROOT}/multiple/approve/page/pagesize/${pagesize}/pagenumber/${pagenumber}`
//   return doGet(url)
// }

// export const getNotApproveMultiPage = (pagesize, pagenumber) => {
//   const url = `${API_ROOT}/multiple/notapprove/page/pagesize/${pagesize}/pagenumber/${pagenumber}`
//   return doGet(url)
// }

export const getWaitingApporveSchema = (approveType) => {
  const url = `${API_ROOT}/approver/multiple/approve/page/${approveType}`
  return doGet(url)
}

export const getWaitingNotApporveSchema = (approveType) => {
  const url = `${API_ROOT}/approver/multiple/reject/page/${approveType}`
  return doGet(url)
}

export const addToWaittingApproveList = (request, approveType) => {
  const url = `${API_ROOT}/approver/multiple/approve/add/${approveType}`
  return doPost(url, request)
}

export const addToWaittingNotApproveList = (request, approveType) => {
  const url = `${API_ROOT}/approver/multiple/reject/add/${approveType}`
  return doPost(url, request)
}

export const deleteWaitingApporveProject = (request, approveType) => {
  const url = `${API_ROOT}/approver/multiple/approve/delete/${approveType}`
  return doDeleteBody(url, request)
}

export const deleteWaitingNotApporveProject = (request, approveType) => {
  const url = `${API_ROOT}/approver/multiple/reject/delete/${approveType}`
  return doDeleteBody(url, request)
}

// export const saveApproveMultiProject = (request) => {
//   const url = `${API_ROOT}/approver/multiple/secure-approve/approve`
//   return doPost(url, request)
// }

// export const saveRejectMultiProject = (request) => {
//   const url = `${API_ROOT}/approver/multiple/secure-approve/reject`
//   return doPost(url, request)
// }

export const submiProjectSecureApproveMulti = (request, approveStatus) => {
  const url = `${API_ROOT}/approver/multiple/secure-approve/submit?approveStatus=${approveStatus}`
  return doPost(url, request)
}

export const submiProjectSecureApproveMultiByType = (request, approveType, approveStatus) => {
  const url = `${API_ROOT}/approver/multiple/secure-approve/submit/${approveType}?approveStatus=${approveStatus}`
  return doPost(url, request)
}
